import { render, staticRenderFns } from "./searchClaim.vue?vue&type=template&id=67e8678e&"
import script from "./searchClaim.vue?vue&type=script&lang=js&"
export * from "./searchClaim.vue?vue&type=script&lang=js&"
import style0 from "./searchClaim.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports